import React from 'react';

import BaseRules from 'components/Tvendo/Sale/QuotaBPartner/Rules/List.js';

export default function () {
  return <BaseRules />;
}
